import { createFileRoute } from '@tanstack/react-router';

import { ProposalSettingsPage } from '../../../features/proposals/ui/settings-page.tsx';
import { requireSettingsPermission } from '../../../lib/permissions.ts';

export const Route = createFileRoute('/_app/settings/proposals')({
  // Настройки сметы и КП (параметры, тарифы поддержки, шаблоны оплат) видит только `proposals.manage`.
  beforeLoad: requireSettingsPermission('proposals.manage'),
  component: ProposalSettingsPage,
});
